// Small text helpers shared by the Worker and the screens, so both write things the same way.

/** "+5", "−5" (a real minus sign, which lines up with the plus) or "0". */
export function signed(n: number): string {
  if (n > 0) return `+${n}`;
  if (n < 0) return `−${-n}`;
  return "0";
}

/**
 * The part of an email before the @: how a grown-up is named wherever children can read it
 * (who tapped, who closed a day), so full addresses never leave the Worker.
 */
export function localPart(email: string): string {
  return email.split("@")[0] || email;
}
